export interface Field {
    id: number;
    title: string;
    type: string;
    dependentFieldIds: undefined | Array<number>;
}

export interface Section {
    fields: Field[];
    id: string;
    hiddenFields: Array<number>;
    isDragDisabled: boolean;
    section: Field;
    isVisible: boolean;
}

export enum FieldTypes {
    FIELD = 'field',
    SECTION = 'section'
}

export interface ServerSideField {
    type: string;
    id: number;
    title: string;
    hidden?: boolean;
    metadata: {
        dependent_parent_id?: number;
    };
    activity_field_data: {
        field_id: string;
        field_version_id: string;
    };
    dependent_field_ids?: Array<number>;
    is_visible?: boolean;
}

export interface DependentFields {
    [key: string]: Array<number>;
}
